import script from "./PaginationFirst.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationFirst.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__